import { SHStack } from "@components/design-systems";
import SHSkeleton from "@components/design-systems/sh-skeleton";
import { useTheme } from "@mui/material";

interface Props {
  numOfItems?: number;
}
export const LineChartSkeleton = ({ numOfItems = 4 }: Props) => {
  const { palette } = useTheme();
  return (
    <SHStack border={`1px solid ${palette.divider}`} padding={2} gap={2}>
      <SHSkeleton width={"60%"} height={20} delay={false} />

      <SHStack direction={"row"} width={"100%"}>
        <SHStack width={35} height={"100%"}>
          <SHSkeleton width={20} height={150} delay={false} />
        </SHStack>

        <SHSkeleton width={"100%"} height={350} delay={false} />
      </SHStack>

      <SHStack direction={"row"} width={"100%"} justifyContent={"flex-end"}>
        <SHSkeleton width={"200px"} height={20} delay={false} />
      </SHStack>

      <SHStack
        direction={"row"}
        width={"100%"}
        gap={2}
        alignItems={"center"}
        justifyContent={"center"}
      >
        {Array.from({ length: numOfItems }).map((_, index) => (
          <SHStack
            key={index}
            direction={"row"}
            height={"100%"}
            gap={2}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <SHSkeleton width={33} height={33} delay={false} />
            <SHStack
              gap={0.5}
              flexGrow={1}
              height={"100%"}
              alignItems={"flex-start"}
              justifyContent={"center"}
            >
              <SHSkeleton width={"100px"} height={18} delay={false} />
              <SHSkeleton width={"60px"} height={18} delay={false} />
            </SHStack>
          </SHStack>
        ))}
      </SHStack>
    </SHStack>
  );
};
